export interface DeploymentChangedEvent {
  previousDeploymentId: string | null;
  deploymentId: string | null;
}

export type DeploymentChangedListener = (event: DeploymentChangedEvent) => void;

let activeDeploymentId: string | null = null;
const listeners = new Set<DeploymentChangedListener>();

/** Returns the deployment currently selected by the application shell. */
export function getActiveDeploymentId(): string | null {
  return activeDeploymentId;
}

/**
 * Updates the application-wide deployment identity and notifies subscribers
 * exactly once when the identity changes.
 */
export function setActiveDeploymentId(deploymentId: string | null): void {
  if (deploymentId === activeDeploymentId) return;

  const event: DeploymentChangedEvent = {
    previousDeploymentId: activeDeploymentId,
    deploymentId,
  };
  activeDeploymentId = deploymentId;

  listeners.forEach((listener) => listener(event));
}

/** Clears the active deployment only if `deploymentId` is still current. */
export function clearActiveDeploymentId(deploymentId: string): void {
  if (activeDeploymentId === deploymentId) {
    setActiveDeploymentId(null);
  }
}

/** Subscribes to application-wide deployment changes. */
export function onDeploymentChanged(listener: DeploymentChangedListener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
